var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inspect-chart",staticStyle:{"color":"#fff"}},[_vm._l((_vm.inspectList),function(data,index){return _c('div',{key:'inspectList' + index,staticClass:"inspect-chart-display"},[_c('canvas-round',{attrs:{"value":data.value,"threshold":data.threshold,"data":data}})],1)}),_c('template',{slot:"loding"},[_vm._t("loding")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }